import { useEffect, useRef, useState } from "react";
import { Pause, Play, RotateCcw } from "lucide-react";
import Scene3D from "./Scene3D";

const SCENES = [
  { id: "flow", label: "Electrical Flow" },
  { id: "scan", label: "Diagnostic Scan" },
  { id: "start", label: "Ready to Start" },
];

export default function HeroShowcase() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const [reduced, setReduced] = useState(false);
  const lastChange = useRef(performance.now());

  useEffect(() => {
    setReduced(window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }, []);

  useEffect(() => {
    const iv = setInterval(() => {
      if (!paused && !document.hidden && performance.now() - lastChange.current > 8000) {
        setActive((a) => (a + 1) % 3);
        lastChange.current = performance.now();
      }
    }, 400);
    return () => clearInterval(iv);
  }, [paused]);

  const pick = (i) => {
    setActive(i);
    lastChange.current = performance.now();
  };

  return (
    <div className="showcase" data-testid="hero-scene-showcase">
      <div className="showcase-tabs">
        {SCENES.map((s, i) => (
          <button key={s.id} type="button" className="scene-tab" aria-pressed={i === active}
            onClick={() => pick(i)} data-testid={`truck-scene-tab-${s.id}`}>
            {s.label}
          </button>
        ))}
        <button type="button" className="scene-pause" aria-label={paused ? "Play animation" : "Pause animation"}
          onClick={() => setPaused((p) => !p)} data-testid="truck-scene-pause-btn">
          {paused ? <Play size={14} /> : <Pause size={14} />}
        </button>
      </div>
      {SCENES.map((s, i) => (
        <div key={s.id} hidden={i !== active} data-testid={`hero-scene-${s.id}`}>
          <Scene3D variant={i} paused={paused || reduced} />
          <div className="scene-label">{s.label}</div>
          <div className="scene-controls">
            <span className="scene-hint"><RotateCcw size={11} style={{ verticalAlign: -1, marginRight: 5 }} />Drag to rotate</span>
            <button type="button" className="scene-pause" aria-label={paused ? "Play animation" : "Pause animation"}
              onClick={() => setPaused((p) => !p)}>
              {paused ? <Play size={14} /> : <Pause size={14} />}
            </button>
          </div>
        </div>
      ))}
      <div className="progress-rail" aria-hidden="true">
        {!paused && !reduced && (
          <div key={active} className="progress-fill" style={{ animation: "progress 8s linear forwards" }} />
        )}
      </div>
    </div>
  );
}
